module.exports = __webpack_public_path__ + "files/bf3e68d3458a6c94af956270d1cc9aff.png";